<!-- <div class="custombg fixed-top">
  <app-header #header></app-header>
  <app-breadcrumb></app-breadcrumb>
</div> -->
<div class="row mt-5" *ngIf="this.viewButton == false">
  <h4 class="ml-5 mt-4 pt-3 mb-0" *ngIf="this.createButton == true"> Add Training</h4>
  <h4 class="ml-5 mt-4 pt-3 mb-0" *ngIf="this.editButton == true"> Edit Training</h4>
  <h4 class="ml-5 mt-4 pt-3 mb-0" *ngIf="this.copyButton == true"> Copy Training</h4>
</div>
<div class="row mt-5" *ngIf="this.viewButton == true">
  <h4 class="ml-5 mt-4 pt-3 mb-0"> View Training</h4>
</div>
<div class="pb-4 justify-content-center">
  <form class="form p-0" [formGroup]="AddTrainingsForm">
    <div class="main-div m-0">
      <div class="row m-4 pt-3">
        <div class="col-sm-2">
          <label id="blue-text"><b>Training Details</b></label>
        </div>
        <div class="horizontal-rule col-sm-10 row pb-4">
          <div class="col-sm-6">
            <label class="labels"><b>Service Line</b><sup>*</sup></label>
            <div id="ServiceDropdown" class="form-group mat-card-header ">
              <select class="form-control ml-1 px-2" formControlName="serviceLines" 
              [(ngModel)]="selectedServiceLine" (change)="subCompetencies()">
              <option disabled [ngValue]="null" selected>-- Select --</option>
              <option *ngFor="let serviceLine of serviceLinesValues" [ngValue]="serviceLine">{{ serviceLine.name }}</option>
              </select>
              <div *ngIf="(AddTrainingsForm.get('serviceLines').dirty || AddTrainingsForm.get('serviceLines').touched) && 
                    AddTrainingsForm.get('serviceLines').invalid && AddTrainingsForm.get('serviceLines').errors">
                <small class="text-danger" *ngIf="AddTrainingsForm.get('serviceLines').hasError('required')">
                  This field is required.
                </small>
              </div>
            </div>

            <label class="labels"><b>Session Name</b><sup>*</sup></label>
            <div class="mat-card-header ">
              <input class="form-control ml-1 py-2 px-2.5" formControlName="sessionName"
                placeholder="Enter session name.." />
            </div>
            <div *ngIf="AddTrainingsForm.get('sessionName').invalid && AddTrainingsForm.get('sessionName').errors && 
                      (AddTrainingsForm.get('sessionName').dirty || AddTrainingsForm.get('sessionName').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('sessionName').hasError('required')">
                This field is required.
              </small>
            </div>

            <div class="">
              <label class="labels"><b>Session Mode</b><sup>*</sup></label>
              <select class="form-control ml-1 px-2" formControlName="sessionMode" [(ngModel)]="selectedTrainingModeId"
                (change)="getSessionModeId($event.target.value)">
                <option selected value=null>-- Select --</option>
                <option *ngFor="let trainingMode of trainingModeValues" [value]="trainingMode.id">{{trainingMode.name}}
                </option>
              </select>
              <div *ngIf="AddTrainingsForm.get('sessionMode').invalid && AddTrainingsForm.get('sessionMode').errors && 
                      (AddTrainingsForm.get('sessionMode').dirty || AddTrainingsForm.get('sessionMode').touched)">
                <small class="text-danger" *ngIf="AddTrainingsForm.get('sessionMode').hasError('required')">
                  This field is required.
                </small>
              </div>
            </div>

            <label class="labels"><b>Trainer Name</b><sup>*</sup></label>
            <div class="mat-card-header">
              <input type="text" class="form-control py-2 px-2.5" formControlName="trainerName" aria-label="Number"
                matInput (input)="searchContributor($event.target.value)" (onfocus)="searchContributor('')"
                [matAutocomplete]="trainer" placeholder="Enter trainer name.." required>
              <mat-autocomplete autoActiveFirstOption #trainer="matAutocomplete"
                (optionSelected)="selectedTrainerName($event)">
                <mat-option *ngFor="let trainer of TrainerNameValue" [value]="trainer.name">
                  {{trainer.employeeId}} &nbsp;&nbsp; {{trainer.name}}
                </mat-option>
              </mat-autocomplete>
              <div *ngIf="AddTrainingsForm.get('trainerName').invalid && AddTrainingsForm.get('trainerName').errors && 
                      (AddTrainingsForm.get('trainerName').dirty || AddTrainingsForm.get('trainerName').touched)">
                <small class="text-danger" *ngIf="AddTrainingsForm.get('trainerName').hasError('required')">
                  This field is required.
                </small>
              </div>
            </div>


          </div>

          <div class="col-sm-6">
            <div class="mat-card-header row">
              <div class="col-6">
                <label class="labels"><b>Competency</b></label>
                <div class="mat-card-header">
                <label class="form-control ml-1 px-2">{{selectedServicelinename}}</label>
              </div>
            </div>
            <div class="col-6">
              <label class="labels"><b>Sub-Competency</b><sup>*</sup></label>
                <select class="form-control ml-1 px-2" formControlName="subServiceline"
                [(ngModel)]="selectedSubServicelineId" (change)="getSubserviceLines($event.target.value)" required>
                <option disabled selected value=null>-- Select --</option>
                <option  *ngFor="let subCompetency of subCompetenciesdropdown" [value]="subCompetency.id">
                  {{subCompetency.name}}</option>
              </select>
            </div>
          </div>
             <div
              *ngIf="AddTrainingsForm.get('subServiceline').invalid && AddTrainingsForm.get('subServiceline').errors && 
                      (AddTrainingsForm.get('subServiceline').dirty || AddTrainingsForm.get('subServiceline').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('subServiceline').hasError('required')">
                This field is required.
              </small>
            </div>

            <label class="labels"><b>Session Type</b><sup>*</sup></label>
            <div class="mat-card-header">
              <select class="form-control ml-1 px-2" formControlName="sessionType" [(ngModel)]="selectedTrainingTypeId"
                (change)="getSessionTypeId($event.target.value)">
                <option disabled selected value=null>-- Select --</option>
                <option *ngFor="let sessiontype of sessionTypeValues" [value]="sessiontype.id">{{sessiontype.name}}
                </option>
              </select>
            </div>
            <div *ngIf="AddTrainingsForm.get('sessionType').invalid && AddTrainingsForm.get('sessionType').errors && 
                      (AddTrainingsForm.get('sessionType').dirty || AddTrainingsForm.get('sessionType').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('sessionType').hasError('required')">
                This field is required.
              </small>
            </div>

            <label class="labels"><b>Session Location</b><sup>*</sup></label>
            <div class="mat-card-header ">
              <select class="form-control ml-1 px-2" formControlName="sessionLocation"
                [(ngModel)]="selectedTrainingLocationId" (change)="getLocationId($event.target.value)" required>
                <option disabled value=null>-- Select --</option>
                <option *ngFor="let sessionLocationValue of sessionLocationValues" [value]="sessionLocationValue.id">
                  {{sessionLocationValue.name}}</option>
              </select>
            </div>
            <div
              *ngIf="AddTrainingsForm.get('sessionLocation').invalid && AddTrainingsForm.get('sessionLocation').errors && 
                      (AddTrainingsForm.get('sessionLocation').dirty || AddTrainingsForm.get('sessionLocation').touched)">
              <small class="text-danger"
                *ngIf="AddTrainingsForm.get('sessionLocation').hasError('required') || selectedTrainingLocationId==null">
                This field is required.
              </small>
            </div>

            <div class="mat-card-header row">

              <div class="col-6">
                <label class="labels mr-2"><b>Start Date</b><sup>*</sup></label>
                <input type="datetime-local" class="form-control py-2 px-2.5"
                  min="{{dateToday() | date:'yyyy-MM-ddTHH:mm:ss.sss'}}" #input formControlName="startDate"
                  (change)="enableEndDate(input.value)">
                <div *ngIf="AddTrainingsForm.get('startDate').invalid && AddTrainingsForm.get('startDate').errors && 
                      (AddTrainingsForm.get('startDate').dirty || AddTrainingsForm.get('startDate').touched)">
                  <small class="text-danger" *ngIf="AddTrainingsForm.get('startDate').hasError('required')">
                    StartDate required.
                  </small>
                </div>
                <div>
                  <small class="text-danger"
                    *ngIf="!AddTrainingsForm.get('startDate').hasError('required') && this.isValidStartDate == false">
                    Invalid-Start-Time.
                  </small>
                </div>
              </div>

              <div class="col-6">
                <label class="labels ml-3"><b>End Date</b><sup>*</sup></label>
                <input type="datetime-local" [min]="AddTrainingsForm.controls.startDate.value"
                  class="form-control py-2 px-2" formControlName="endDate" #inputStart
                  (change)="validateEndTime(inputStart.value)">
                <div *ngIf="AddTrainingsForm.get('endDate').invalid && AddTrainingsForm.get('endDate').errors && 
                      (AddTrainingsForm.get('endDate').dirty || AddTrainingsForm.get('endDate').touched)">
                  <small class="text-danger" *ngIf="AddTrainingsForm.get('endDate').hasError('required')">
                    EndDate required.
                  </small>
                </div>
                <div>
                  <small class="text-danger"
                    *ngIf="!AddTrainingsForm.get('endDate').hasError('required') && this.isValidEndDate == false">
                    Invalid-End-Time.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <label class="labels"><b>Attendee Emails</b></label>
            <div>
              <textarea class="form-control px-2.4" id="exampleFormControlTextarea1" formControlName="emailInputString"
                rows="3" (blur)="emailValidator()" placeholder="Enter semicolon seperated emails.."></textarea>
            </div>
            <div *ngIf="invalidEmails?.length >= '1'" class="text-danger">
              Following emails are invalid:
              <span *ngFor="let invalidEmail of invalidEmails">'{{invalidEmail}}', </span>
            </div>
            <div *ngIf="isEmailCount == true && invalidEmails?.length == '0'" class="text-danger">
              number of emails should not be greater than resources
            </div>
          </div>
        </div>
      </div>

      <div class="row m-4">
        <div class=" col-sm-2">
          <label id="blue-text"><b>Additional Details</b></label>
        </div>
        <div class="horizontal-rule col-sm-10 row pb-4">
          <div class="col-sm-6">
            <div class="">
              <label class="labels"><b>Total Number of Resources Planned</b><sup>*</sup></label>
              <input type="number" min="0" oninput="validity.valid||(value='');" (blur)="emailCount()"
                class="form-control py-2 px-2.5" formControlName="noofPlannedResources"
                placeholder="Enter number of resources.." required />
            </div>
            <div
              *ngIf="AddTrainingsForm.get('noofPlannedResources').invalid && AddTrainingsForm.get('noofPlannedResources').errors && 
                      (AddTrainingsForm.get('noofPlannedResources').dirty || AddTrainingsForm.get('noofPlannedResources').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('noofPlannedResources').hasError('required')">
                This field is required.
              </small>
              <small *ngIf="AddTrainingsForm.get('noofPlannedResources').hasError('noMatch')">
                emails are greater than resources.
              </small>
            </div>

          </div>

          <div class="col-sm-6">
            <div class="">
              <label class="labels"><b>Prerequisites Tools Required</b><sup>*</sup></label>
              <input class="form-control py-2 px-2.5" formControlName="toolsRequired"
                placeholder="Enter required tools.." required />
            </div>
            <div *ngIf="AddTrainingsForm.get('toolsRequired').invalid && AddTrainingsForm.get('toolsRequired').errors && 
                      (AddTrainingsForm.get('toolsRequired').dirty || AddTrainingsForm.get('toolsRequired').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('toolsRequired').hasError('required')">
                This field is required.
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="row m-4">
        <div class=" col-sm-2">
          <label id="blue-text"><b>Recording Location</b></label>
        </div>

        <div class="horizontal-rule col-sm-10 row pb-4">
          <div class=" col-sm-6">
            <div class="">
              <label class="labels"><b>Session Recording Location</b><sup>*</sup></label>
              <input class="form-control py-2 px-2.5" formControlName="sessionURL"
                placeholder="Enter session recording location.." required />
            </div>
            <div *ngIf="AddTrainingsForm.get('sessionURL').invalid && AddTrainingsForm.get('sessionURL').errors && 
                      (AddTrainingsForm.get('sessionURL').dirty || AddTrainingsForm.get('sessionURL').touched)">
              <small class="text-danger" *ngIf="AddTrainingsForm.get('sessionURL').hasError('required')">
                This field is required.
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row justify-content-end p-4" *ngIf="this.viewButton == false">
        <button type="reset" (click)="backToTrainingGrid()" class="custom_btn inverted_btn_base btn-lg me-2 mr-4">Cancel</button>
        <button type="button" class="custom_btn primary_btn_base btn-lg mr-4" *ngIf="this.createButton == true"
          [disabled]="invalidEmails.length!=0 || !AddTrainingsForm.valid || isEmailCount==true || this.isValidEndDate == false"
          (click)="createTraining()">Create</button>
        <button type="button" class="custom_btn primary_btn_base btn-lg mr-4" *ngIf="this.editButton == true"
          [disabled]="invalidEmails.length!=0 || !AddTrainingsForm.valid || isEmailCount==true || this.isValidEndDate == false"
          (click)="editTraining()"> Edit </button>
        <button type="button" class="custom_btn primary_btn_base btn-lg mr-4" *ngIf="this.copyButton == true"
          [disabled]="invalidEmails.length!=0 || !AddTrainingsForm.valid || isEmailCount==true || this.isValidEndDate == false"
          (click)="copyTraining()">Save</button>
      </div>

      <div class="form-group row justify-content-end p-4" *ngIf="this.viewButton == true">
        <button type="button" (click)="backToTrainingGrid()" class="custom_btn inverted_btn_base btn-lg me-2 mr-4">Back</button>
      </div>

    </div>
  </form>
</div>